<template>
  <div class="company-container">
    <div class="title">{{$t('home.Company')}}</div>
    <div class="item-container">
      <div class="item" v-for="(item, index) in companyList" :key="index" @click="handleCrop(item)">
        <slot :company="item"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapMutations } = createNamespacedHelpers('collaborator')
export default {
  name: 'company',
  props: {
    companyList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    ...mapMutations(['setSearchVal', 'setSearchCropVal']),
    handleCrop(item) {
      this.setSearchVal(item.name)
      this.setSearchCropVal(item.name)
    }
  }
}
</script>

<style scoped lang="less">
.company-container {
  .title {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: #F7F8FA;
    font-size: 16px;
    font-weight: 500;
    color: #999B9F;
    padding-left: 30px;
  }
  .item-container {
    padding: 0 8px;
  }
  .item {
    display: flex;
    align-items: center;
    height: 40px;
    background: #fff;
    padding-left: 40px;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    &:hover {
      cursor: pointer;
      background-color: #F3F6FB;
    }
    .org-icon {
      margin-right: 12px;
    }
  }
}
</style>
